module.exports = __webpack_public_path__ + "img/BLCA_B.091ead69.png";